import { Input } from "@/components/Input";
import { makePlatformOnClick } from "@/components/utils";
import { OrderType, Payments } from "@/constants";
import { Setup } from "@/types";
import { cn } from "@/libs";
import { Button, Popup, PopupProps, SafeArea, Selector } from "antd-mobile";
import { ActionType, PageState } from "../logic";
import styles from "./Filter.module.scss";
export interface ListFilterProps extends PopupProps {
  logic: Setup.Logic<PageState, ActionType> & {
    resetFilters: () => void;
    applyFilters: () => void;
  };
}

const tradePaymentOptions = [
  {
    label: <span className={styles.typeBox}><span className={cn(styles.icon,styles.bank)}></span>银行卡</span>,
    value: Payments.BANK,
  },
  {
    label: <span className={styles.typeBox}><span className={cn(styles.icon,styles.wechat)}></span>微信</span>,
    value: Payments.WE_CHAT,
  },
  {
    label: <span className={styles.typeBox}><span className={cn(styles.icon,styles.alipay)}></span>支付宝</span>,
    value: Payments.ALI,
  },
  {
    label: <span className={styles.typeBox}><span className={cn(styles.icon,styles.digital_rmb)}></span>数字人民币</span>,
    value: Payments.DIGITAL_RMB,
  },
];

const tradeSplitOptions = [
  {
    label: "可拆分",
    value: OrderType.SEPARABLY,
  },
  {
    label: "不可拆分",
    value: OrderType.INSEPARABLY,
  },
];

export const ListFilter = ({ visible, logic, ...rest }: ListFilterProps) => {
  return (
    <Popup
      visible={visible}
      showCloseButton={true}
      {...rest}
      bodyClassName={styles.body}
    >
      <div className={styles.title}>筛选</div>
      <div className={styles.content}>
        <div className={styles.fieldTitle}>金额</div>
        <Input
          theme="plain"
          className={styles.filed}
          value={logic.state.amount}
          extra={
            <Button
              fill="none"
              className={styles.fieldClear}
              {...makePlatformOnClick((e) => {
                // e.preventDefault();
                logic.dispatch({ type: "update-amount", amount: "" });
              })}
            >
              清除
            </Button>
          }
          onChange={(e) => {
            // logic.dispatch({ type: "update-amount", amount: /^\d+$/.test(e.target.value) && Number(e.target.value) > 99999999 ? '99999999': e.target.value });
            logic.dispatch({ type: "update-amount", amount: e.target.value });
          }}
        />
        <div className={styles.fieldTitle}>交易方式</div>
        <Selector
          className={styles.selector}
          value={logic.state.paymentType}
          showCheckMark={false}
          multiple={true}
          options={tradePaymentOptions}
          onChange={(v) => {
            logic.dispatch({ type: "update-paymentType", paymentType: v });
          }}
        />
        <div className={styles.fieldTitle}>是否可拆分</div>
        <Selector
          className={styles.selector}
          value={logic.state.isSplit}
          showCheckMark={false}
          options={tradeSplitOptions}
          onChange={(v) => {
            logic.dispatch({ type: "update-isSplit", isSplit: v });
          }}
        />
        <div className={styles.buttonGroup}>
          <Button
            className={styles.resetButton}
            onClick={() => {
              logic.resetFilters();
            }}
          >
            重置
          </Button>
          <Button
            className={styles.applyButton}
            onClick={() => {
              logic.applyFilters();
            }}
          >
            应用
          </Button>
        </div>
        <div className={styles.bottomPrompt}>仅显示可用的交易方式</div>
      </div>
      <SafeArea position="bottom" />
    </Popup>
  );
};
